// eslint-disable-next-line @typescript-eslint/no-unused-vars
import * as React from 'react';

const TITLE = 'Chevron';

export function LineChevronLeft() {
  return (
    <svg
      width="24"
      height="24"
      aria-label="Chevron Line Left"
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3H5V21H7V3ZM19.46 19.5387L11.9216 11.9954L19.4595 4.46225L17.9982 3L8.99798 11.9945L17.9977 21L19.46 19.5387Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronRight() {
  return (
    <svg
      width="24"
      height="24"
      aria-label="Chevron Line Right"
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21H19L19 3H17L17 21ZM4.54 4.46132L12.0784 12.0046L4.54047 19.5377L6.00179 21L15.002 12.0055L6.00225 3L4.54 4.46132Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronUp() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 7V5L3 5V7L21 7ZM4.46132 19.46L12.0046 11.9216L19.5377 19.4595L21 17.9982L12.0055 8.99798L3 17.9977L4.46132 19.46Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronDown() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 17V19H21V17H3ZM19.5387 4.54L11.9954 12.0784L4.46225 4.54047L3 6.00179L11.9945 15.002L21 6.00225L19.5387 4.54Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronLeftThin() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 3H6V21H7V3ZM18.7627 3.76231L10.5251 12.0051L18.7624 20.2372L18.0001 21L9 12.0056L17.9999 3L18.7627 3.76231Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronRightThin() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17 21H18L18 3H17L17 21ZM5.23732 20.2377L13.4749 11.9949L5.23757 3.7628L5.99988 3L15 11.9944L6.00012 21L5.23732 20.2377Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronUpThin() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21 7V6L3 6V7L21 7ZM20.2377 18.7627L11.9949 10.5251L3.7628 18.7624L3 18.0001L11.9944 9L21 17.9999L20.2377 18.7627Z"
        fill="currentColor"
      />
    </svg>
  );
}

export function LineChevronDownThin() {
  return (
    <svg
      width="24"
      height="24"
      aria-label={TITLE}
      role="img"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{TITLE}</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 17V18H21V17H3ZM3.76231 5.23732L12.0051 13.4749L20.2372 5.23757L21 5.99988L12.0056 15L3 6.00012L3.76231 5.23732Z"
        fill="currentColor"
      />
    </svg>
  );
}
